<template>
    <v-layout wrap justify-center align-center>
        <v-flex xs12>
            <v-form v-model="valid">
                <v-text-field
                        @keydown.enter.prevent.stop="send"
                        label="Contraseña"
                        placeholder="Escribe nueva contraseña"
                        v-model="password"
                        :rules="passwordRules"
                        :loading="loading"
                        append-outer-icon="send"
                        :type="showPassword ? 'text' : 'password'"
                        :append-icon="showPassword ? 'fas fa-eye' : 'fas fa-eye-slash'"
                        @click:append="showPassword = !showPassword"
                        @click:append-outer="send"
                />
            </v-form>
        </v-flex>
    </v-layout>
</template>

<script>

    import {ApiUtils} from '@/utils/ApiUtils'
    import {mapMutations} from 'vuex'

    export default{
        props: ['endpoint', 'code', 'customData'],
        data(){
            return{
                valid: false,
                password: '',
                loading: false,
                showPassword: false,
                passwordRules: [
                        v => v.length >= 6 || 'La contraseña debe tener al menos 6 caracteres'
                ]
            }
        },
        methods: {
            ...mapMutations(['showSnackBar']),
            async send(){

                var vm = this
                if (vm.loading) return

                if(!vm.valid){
                    vm.showSnackBar('La contraseña es inválida')
                    return
                }

                var payload = {
                    code: vm.code,
                    password: vm.password,
                    password_confirmation: vm.password
                }

                if(vm.customData){
                    payload = {
                            ...payload,
                            ...vm.customData
                    }
                }

                vm.loading = true
                const response = await ApiUtils.makePost(vm.endpoint, payload)
                vm.loading = false

                if(!response.ok){
                    const json = await response.json()
                    vm.$emit('error', json)
                    return
                }

                vm.$emit('success')

            }
        }
    }
</script>